import script from "./PointCharge.vue?vue&type=script&setup=true&lang=js"
export * from "./PointCharge.vue?vue&type=script&setup=true&lang=js"

import "./PointCharge.vue?vue&type=style&index=0&id=e673c6aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e673c6aa"]])

export default __exports__